// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutMeContact_container__3G23H","contact_data":"AboutMeContact_contact_data__3rwDw","phone":"AboutMeContact_phone__1l-Nl","email":"AboutMeContact_email__3KN6p"};